import React, { PureComponent } from 'react';

import './BasketOrderTotal.scss';

import { BasketPriceModel } from 'models/Basket';
import { formatCurrency } from 'formatters';

interface OwnProps {
    discounts: BasketPriceModel;
    totalPriceWithTax: BasketPriceModel;
    includeDelivery: boolean;
    isDeliveryCostFree: boolean;
}

export class BasketOrderTotal extends PureComponent<OwnProps> {
    render(): JSX.Element {
        return (
            <div className='basket-order-total'>
                {this.hasDiscount(this.props.discounts) && this.renderTotalDiscount()}
                {this.renderOrderTotal()}
            </div>
        );
    }

    renderTotalDiscount(): JSX.Element {
        return (
            <>
                <div className='basket-order-total__row'>
                    <div className='basket-order-total__title'>Total Discount</div>
                    <div className='basket-order-total__value'>- {formatCurrency(this.props.discounts.value)}</div>
                </div>
                <div className='basket-order-total__separator' />
            </>
        );
    }

    renderOrderTotal(): JSX.Element {
        return <div className='basket-order-total__row'>
            <div className='basket-order-total__title'>Order Total</div>
            <div className='basket-order-total__value'>
                {this.props.includeDelivery
                    ? <>
                        {formatCurrency(this.props.totalPriceWithTax.value)}
                        {this.props.isDeliveryCostFree
                            ? <div className='basket-order-total__delivery'>including free delivery</div>
                            : <div className='basket-order-total__delivery'>including delivery</div>
                        }
                    </>
                    : <div>{formatCurrency(this.props.totalPriceWithTax.value)}</div>
                }
            </div>
        </div>;
    }

    hasDiscount(discount: BasketPriceModel) {
        return discount.value > 0;
    }
}